import { useEffect } from 'react';
import { usePlaidLink, PlaidLinkOnSuccessMetadata, PlaidLinkOnExitMetadata, PlaidLinkError, PlaidLinkOptionsWithLinkToken } from 'react-plaid-link';

interface Props {
  isIncome?: boolean;
  token: string;
  successCallback: (publicToken: string, linkSessionId?: string) => Promise<void>;
  exitCallback?: (error: PlaidLinkError | null, metadata: PlaidLinkOnExitMetadata) => void;
  successMetadataCallback?: (metadata: PlaidLinkOnSuccessMetadata) => void;
}

/**
 * Launches Link, calling props.successCallback when complete. This could have
 * been combined with the LinkLoader, but it got a bit unweildy
 */
export default function LaunchLink(props: Props) {
  // No logging of the public token or Link metadata: they reach the browser console, and from
  // there session recordings and support screenshots.
  const onSuccess = async (publicToken: string, metadata: PlaidLinkOnSuccessMetadata) => {
    try {
      await props.successCallback(publicToken, metadata?.link_session_id ?? undefined);
    } finally {
      // Recorded even when the success handling fails, so the Link session is never lost.
      try {
        props.successMetadataCallback?.(metadata);
      } catch (e) {
        console.log('successMetadataCallback error (non-fatal)', e);
      }
    }
  };

  const onExit = async (error: PlaidLinkError | null, metadata: PlaidLinkOnExitMetadata) => {
    try {
      props.exitCallback?.(error, metadata);
    } catch (e) {
      console.log('exitCallback error (non-fatal)', e);
    }
  };

  const config: PlaidLinkOptionsWithLinkToken = {
    onSuccess,
    onExit,
    onLoad: () => {},
    token: props.token,
  };

  const { open, ready } = usePlaidLink(config);

  useEffect(() => {
    if (ready) {
      open();
    }
  }, [ready, open, props.token]);

  return <></>;
}
